<section class="mypxs-ch rs-neg rs-overlapped">
  <div class="row">
    <div
      class="columns small-12 medium-10"
      data-cy="myBillExplanationScreenHeader"
    >
      <my-bill-back-button
        [backButtonType]="'leftArrowPlainText'"
      ></my-bill-back-button>
      <h1>
        {{
          'bills.billExplanations.' + billExplanationType + '.pageTitle'
            | translate
        }}
      </h1>
    </div>
  </div>
</section>
<section class="rs-overlapping">
  <div class="rs-fe3"></div>

  <div class="row">
    <div class="columns small-12">
      <div class="row rs-xpandgrid">
        <!--///////////////   LEFT PANELS   //////////////////-->
        <div class="columns small-12 medium-7">
          <div class="rs-panel-big rs-bg-c2 clearfix">
            <div class="rs-flex-row">
              <div
                class="rs-flex-columns rs-order-m2"
                [innerHTML]="
                  'bills.billExplanations.' +
                    billExplanationType +
                    '.description' | translate
                "
                *ngIf="
                  ('bills.billExplanations.' +
                    billExplanationType +
                    '.description' | translate) !== ' '
                "
                data-cy="myBillExplanationScreenFirstInnerHtml"
              ></div>
              <div
                class="rs-flex-columns rs-order-m1"
                *ngIf="(topImageUrl | translate) !== ' '"
                data-cy="myBillExplanationScreenTopImage"
              >
                <img
                  class="show-for-small-only"
                  src="{{ topImageUrlForSmall | translate }}"
                  alt=""
                  loading="lazy"
                />
                <img
                  class="show-for-medium-up"
                  src="{{ topImageUrl | translate }}"
                  alt=""
                  loading="lazy"
                />
              </div>
            </div>
            <div
              class="rs-me"
              *ngIf="
                ('bills.billExplanations.' +
                  billExplanationType +
                  '.description' | translate) !== ' ' ||
                ('bills.billExplanations.' +
                  billExplanationType +
                  '.topImageUrl' | translate) !== ' '
              "
            ></div>
            <span
              [innerHTML]="
                'bills.billExplanations.' +
                  billExplanationType +
                  '.descriptionList' | translate
              "
              *ngIf="
                ('bills.billExplanations.' +
                  billExplanationType +
                  '.descriptionList' | translate) !== ' '
              "
              data-cy="myBillExplanationScreenSecondInnerHtml"
            ></span>

            <div class="rs-me"></div>
            <div class="panel rs-bg-grey2">
              <div class="rs-flex-row rs-flex-middle">
                <div
                  class="rs-flex-column rs-flex-shrink"
                  data-cy="myBillExplanationScreenTipImage"
                >
                  <img
                    class="show-for-small-only"
                    src="{{
                      'bills.billExplanations.' +
                        billExplanationType +
                        '.tipImageS' | translate
                    }}"
                    alt=""
                    loading="lazy"
                  />
                  <img
                    class="show-for-medium-up"
                    src="{{
                      'bills.billExplanations.' +
                        billExplanationType +
                        '.tipImage' | translate
                    }}"
                    alt=""
                    loading="lazy"
                  />
                </div>
                <div
                  class="rs-flex-column"
                  data-cy="myBillExplanationScreenTipTitle"
                >
                  <p class="rs-tit4">
                    {{
                      'bills.billExplanations.' + billExplanationType + '.tip'
                        | translate
                    }}
                  </p>
                </div>
              </div>
              <span
                [innerHTML]="
                  'bills.billExplanations.' +
                    billExplanationType +
                    '.tipDescription' | translate
                "
                data-cy="myBillExplanationScreenTipDescription"
              ></span>
              <div
                class="rs-flex-row rs-flex-dir-col-small-only"
                *ngIf="
                  ('bills.billExplanations.' +
                    billExplanationType +
                    '.hasTwoTipLinks' | translate) === 'true';
                  else showDefaultTip
                "
              >
                <div class="rs-flex-column rs-flex-shrink-medium">
                  <a
                    href="{{
                      'bills.billExplanations.' +
                        billExplanationType +
                        '.tipLink1.' +
                        segment +
                        'Url' | translate
                    }}"
                    class="rs-btn rs-btn-third rs-no-margin"
                    data-cy="myBillExplanationScreenTipLink1"
                  >
                    {{
                      'bills.billExplanations.' +
                        billExplanationType +
                        '.tipLink1.' +
                        segment | translate
                    }}
                    <i
                      class="rs-icon-btn-third rs-margin-left1"
                      aria-hidden="true"
                    >
                    </i
                  ></a>
                </div>

                <div class="rs-flex-column">
                  <a
                    href="{{
                      'bills.billExplanations.' +
                        billExplanationType +
                        '.tipLink2.' +
                        segment +
                        'Url' | translate
                    }}"
                    class="rs-btn rs-btn-third"
                  >
                    {{
                      'bills.billExplanations.' +
                        billExplanationType +
                        '.tipLink2.' +
                        segment | translate
                    }}
                    <i
                      class="rs-icon-btn-third rs-margin-left1"
                      aria-hidden="true"
                    >
                    </i
                  ></a>
                </div>
              </div>
              <ng-template #showDefaultTip>
                <a
                  href="{{
                    'bills.billExplanations.' +
                      billExplanationType +
                      '.tipLink1.' +
                      segment +
                      'Url' | translate
                  }} "
                  class="rs-btn rs-btn-third"
                  data-cy="myBillExplanationScreenTipLink1"
                >
                  {{
                    'bills.billExplanations.' +
                      billExplanationType +
                      '.tipLink1.' +
                      segment | translate
                  }}
                  <i
                    class="rs-icon-btn-third rs-margin-left1"
                    aria-hidden="true"
                  >
                  </i
                ></a>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="rs-le2"></div>
</section>
